export const STARGATE_URL = '/gateway/api';
export const ONBOARDING_ENGAGEMENT_ID = 'jira-nin-statistics-onboarding-spotlight';
export const ONBOARRDING_ENGAGEMENT_RELAUNCH_ID = 'jira_helios_nin_statistics_onboarding';
export const ONBOARDING_STATISTICS_TRY_IT_OUT_BUTTON_ID = 'jiraNinStatisticsOnboardingTryItOut';
export const ONBOARDING_STATISTICS_DISMISS_BUTTON_ID = 'jiraNinStatisticsOnboardingDismiss';
export const ONBOARDING_STATISTICS_SPOTLIGHT_ID = 'jiraNinStatisticsOnboardingSpotlight';
